(() => {
	const MOBILE_BREAKPOINT = '(max-width: 749px)';
	const WRAPPER_SELECTOR = '.buy-buttons-wrapper';
	const BOTTOM_THRESHOLD = 8;

	const isMobileViewport = () => window.matchMedia(MOBILE_BREAKPOINT).matches;
	const isAtPageBottom = () => {
		const viewportBottom = window.scrollY + window.innerHeight;
		const pageHeight = document.documentElement.scrollHeight;
		return viewportBottom >= pageHeight - BOTTOM_THRESHOLD;
	};

	const setBottomVisibilityState = (wrapper, hideAtBottom) => {
		wrapper.classList.toggle('is-hidden-for-footer', hideAtBottom && isMobileViewport());
	};

	const initStickyFooterVisibility = (root = document) => {
		const wrappers = root.querySelectorAll(WRAPPER_SELECTOR);
		if (!wrappers.length) return;

		wrappers.forEach((wrapper) => {
			if (wrapper.dataset.footerWatchInit === 'true') return;

			const updateOnScroll = () => {
				setBottomVisibilityState(wrapper, isAtPageBottom());
			};

			updateOnScroll();
			window.addEventListener('scroll', updateOnScroll, { passive: true });
			window.addEventListener('resize', updateOnScroll);

			wrapper.dataset.footerWatchInit = 'true';
		});
	};

	document.addEventListener('DOMContentLoaded', () => initStickyFooterVisibility());
	document.addEventListener('shopify:section:load', (event) => initStickyFooterVisibility(event.target || document));
})();
